import { ActingPersonSection } from "Components/AML/AMLUserDetail/LegalEntityContent/ActingPersonSection";
import { BeneficialOwnersSection } from "Components/AML/AMLUserDetail/LegalEntityContent/BeneficialOwnersSection";
import { VerificationsSection } from "Components/AML/AMLUserDetail/shared/VerificationsSection";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { RegistryLinks } from "Components/Shared/RegistryLinks/RegistryLinks";
import { ValueItems } from "Components/Shared/ValuesBox/ValueItems";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import type { PartyDto, UserVerificationDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { getFormattedAddress } from "Utils/AddressUtils";
import { formatPhone } from "Utils/PhoneUtils";

type Props = {
  partyData: PartyDto;
  verificationData: UserVerificationDto;
};

export const LegalEntityContent = ({
  partyData: {
    type,
    addresses,
    companyName,
    companyNumber,
    phone,
    email,
    taxNumber,
    publicID,
    relatedParties,
  },
  verificationData,
}: Props) => {
  const { t } = useResource();

  if (!publicID) {
    return <ErrorText>{t(Resources.Error.UserFailed)}</ErrorText>;
  }

  return (
    <>
      <ValuesBox title={t(Resources.AML.BasicInfo)}>
        <ValueItems
          values={[
            { label: "Typ", value: t(Resources.Form.PartyType[type]) },
            { label: t(Resources.AML.CompanyName), value: companyName },
            { label: t(Resources.AML.CompanyNumber), value: companyNumber },
            { label: t(Resources.AML.TaxNumber), value: taxNumber },
            ...addresses.map((address) => ({
              label: t(Resources.Form.AddressType[address.type]),
              value: getFormattedAddress(address),
            })),
            { label: t(Resources.AML.Phone), value: formatPhone(phone) },
            { label: "Email", value: email },
          ]}
        />
      </ValuesBox>
      {companyNumber && <RegistryLinks companyNumber={companyNumber} />}
      <VerificationsSection
        verificationData={verificationData}
        partyType={type}
      />
      <ActingPersonSection owningPartyID={publicID} />
      <BeneficialOwnersSection
        owningPartyID={publicID}
        relatedParties={relatedParties}
        isUboUnknown={verificationData.uboUnknown}
      />
    </>
  );
};
